import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { AdminSpacesList } from '@components/templates/admin/spaces';

export const SpacesManagement = () => {
    const { t } = useTranslation();

    const translations = {
        title: t('admin.spaces-management.metatags.title'),
        description: t('admin.spaces-management.metatags.description'),
    };

    useSEOMetatags({
        ...translations,
        url: SITE_URLS.mySpaces,
        index: false,
    });

    return <AdminSpacesList />;
};
